import React, { Fragment, useState, useEffect } from 'react'
import MenuHeader from './MenuHeader'
import { Map } from './google_map';
import HotelList from './HotelList';
import HotelDetails from './HotelDetails';
import HotelService from '../services/hotel.service';
import useApi from '../hooks/useApi';
import useAuth from '../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import BookingService from "../services/booking.service";
import Modal from "react-modal";
import { useTranslation } from 'react-i18next';
import { useLoadScript } from '@react-google-maps/api';

const googleMapsLibraries = ['places'];

const customStyles2 = {
  content: {
    width: "33%",
    top: "50%",
    padding: "0px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "0px",
    boxShadow: "none",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

Modal.setAppElement("#root");

function Hotel() {
  const [hotels, setHotels] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);
  const axionPrivate = useApi();
  const { auth } = useAuth();
  const location = useLocation();
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [showList, setShowList] = useState(true);
  const [showHotelDetails, setShowHotelDetails] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const api = useApi();
  const [modalIsOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('hotel');
  const { isLoaded: isMapLoaded, loadError: mapLoadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: googleMapsLibraries,
  });
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const fetchBookings = async () => {
    try {
      const response = await BookingService.index({ with: 'hotel', hotel_id: '!eq:null', client_id: `${auth?.user ? auth.user.id : -1}` }, api);
      setBookings(response)
    } catch (error) {

    }
  }

  const fetchHotels = async () => {
    try {
      const hotels = await HotelService.index({ with: 'media,address', is_only_internal: false }, axionPrivate, auth?.user ? false : true)
      setHotels(hotels);
      setFilteredHotels(hotels);
      const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
      const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
      if (isEditMode && oldBooking.hotel_id != null) {
        const matchingHotels = hotels.filter(hotel => hotel.id === oldBooking.hotel_id);
        console.log({ matchingHotels })
        if (matchingHotels.length > 0) {
          console.log({ matchingHotels })
          setSelectedHotel(matchingHotels[0]);
          setShowHotelDetails(true);
        }
      }
    } catch (error) {

    }
  }
  useEffect(() => {
    fetchHotels();
    fetchBookings();
  }, [])

  useEffect(() => {
    setIsOpen(true);
  }, []);
  useEffect(() => {
    const hotelDataFromSession = sessionStorage.getItem("selectedHotel");

    // First check if hotel was passed from navigation state (popup confirmation)
    if (location.state?.hotel && hotels.length > 0) {
      const matchingHotel = hotels.find(hotel => hotel.id === location.state.hotel.id);
      if (matchingHotel) {
        setSelectedHotel(matchingHotel);
        setShowHotelDetails(true);
        // Store in sessionStorage for consistency
        sessionStorage.setItem("selectedHotel", JSON.stringify(matchingHotel));
      }
    }
    // Otherwise check sessionStorage
    else if (hotelDataFromSession && hotels.length > 0) {
      const hotelObj = JSON.parse(hotelDataFromSession);
      const matchingHotel = hotels.find(hotel => hotel.id === hotelObj.id);
      if (matchingHotel) {
        setSelectedHotel(matchingHotel);
        setShowHotelDetails(true);
      }
    }
  }, [hotels, location.state]);

  const handleShowHotelMapClick = (hotel) => {
    setSelectedHotel(hotel);
    setShowList(false);
    setShowHotelDetails(false);
  };

  const handleHotelClick = (hotel) => {
    setSelectedHotel(hotel);
    setShowHotelDetails(true)
  };

  const handleHotelFilter = (filter) => {
    setFilteredHotels(hotels.filter(hotel => hotel.name.toLowerCase().includes(filter.toLowerCase())));
  };

  const handleMapClick = () => {
    setShowList(false);
    setShowHotelDetails(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    if (screenWidth < 992 && showHotelDetails) {
      setShowList(false);
    }
  }, [screenWidth, showHotelDetails]);

  useEffect(() => {
    if (screenWidth < 992 && showList) {
      setShowHotelDetails(false);
    }
  }, [screenWidth, showList]);
  return (
    <Fragment>
      <MenuHeader />
      {isMapLoaded ? (
        <Map hotels={filteredHotels} selectedHotel={selectedHotel} onClick={handleMapClick} onHotelClick={handleHotelClick} />
      ) : (
        <div className="map-container" role="status" style={{ minHeight: 'calc(100vh - 80px)', display: 'grid', placeItems: 'center' }}>
          {t(mapLoadError ? 'map_load_error' : 'map_loading')}
        </div>
      )}
      {!showList && (<button className='toggle-hotel-view' onClick={() => setShowList(true)}><img src='/assets/images/icon-hotel.svg' height={30} /></button>)}
      {showList && (<HotelList hotels={filteredHotels} selectedHotel={selectedHotel} onHotelShowMapClick={handleShowHotelMapClick} onHotelClick={handleHotelClick} onHotelFilter={handleHotelFilter} />)}
      {selectedHotel && showHotelDetails && (
        <HotelDetails hotel={selectedHotel} center={!showList} />
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles2}
        contentLabel="Example Modal"
        id="custom-popup-content"
      >
        <div className="contentModal">
          <div className="modal">
            <p className="modal-text text-birth">
              {t('choice')}
              {/* {t('birth-text')} */}
            </p>
          </div>
          <div className="modal-button-container hotel-modal-btn">
            <button className="modal-ok-button" onClick={closeModal} >Ok</button>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
}

export default Hotel;
